/** A valid WhatsApp number: "+", country code and number, 8 to 15 digits in total (E.164). */
export const limpiarWhatsapp = (raw) => String(raw || '').replace(/[\s\-()]/g, '');
export const whatsappValido = (number) => /^\+[1-9][0-9]{7,14}$/.test(limpiarWhatsapp(number));
